import { t } from 'i18next'
import { Text } from '../../atoms'
import { CategoryColumn, MoveableCard } from '../../molecules'
import { ImmobileCard } from '../../molecules/immobile-card'

export const MoveableCards = ({
  items,
  dragIndex,
  setDragIndex,
  moveCard,
  fixedItems
}: {
  items: CategoryColumn[]
  dragIndex?: number
  setDragIndex: (value?: number) => void
  moveCard: (dragIndex: number, hoverIndex: number) => void
  fixedItems?: CategoryColumn[]
}) => {
  return (
    <div className="flex flex-col gap-6">
      <Text as="h2" textType="lg" className="mb-2">
        {t('glow.orderOfTable')}
      </Text>
      <div className="overflow-y-auto h-[calc(100vh-14rem-4rem)] flex flex-col gap-6">
        {fixedItems && fixedItems.length > 0 && (
          <div>
            <Text as="p" textType="base" className="mb-4">
              {t('glow.fixedTableHeadersDescription')}
            </Text>
            {fixedItems.map((item, index) => (
              <ImmobileCard key={item.key} column={item} index={index} />
            ))}
          </div>
        )}
        {items.length > 0 && (
          <div>
            <Text as="p" textType="base" className="mb-4">
              {t('glow.orderOfTableDescription')}
            </Text>
            {items.map((item, index) => (
              <MoveableCard
                isDragging={dragIndex === index}
                key={item.key}
                column={item}
                dragIndex={dragIndex}
                onDrag={setDragIndex}
                index={index}
                moveCard={moveCard}
                countOffset={fixedItems?.length ?? 0}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
